import React, { useState } from "react";
import "../css/Faqs.css";

const Faqs = () => {
  const [active, setActive] = useState(null);

  const toggleFAQ = (index) => {
    setActive(active === index ? null : index);
  };

  const faqs = [
    {
      q: "What makes FLEXOR different?",
      a: "FLEXOR focuses on biomechanical precision, mental flow-state training, and minimalistic performance-driven environments."
    },
    {
      q: "Do I need experience to join?",
      a: "No. All programs are adaptive. Whether you're a beginner or competitive athlete, FLEXOR coaches tailor your progress."
    },
    {
      q: "Are your coaches certified?",
      a: "Yes. Every FLEXOR coach is performance-certified with specialization in form correction, strength mechanics, and conditioning science."
    },
    {
      q: "Do you offer custom workout plans?",
      a: "Absolutely. FLEXOR builds individualized progression systems aligned with your lifestyle, goals, and physical composition."
    },
    {
      q: "Is nutrition guidance available?",
      a: "Yes — our specialists craft evidence-based nutritional baselines optimized for energy, muscle growth, and recovery."
    },
  ];

  return (
    <div className="faqs2">

      {/* HERO */}
      <section className="faqs2-hero">
        <div className="faqs2-hero-inner">
          <h1>FAQs</h1>
          <p>Your questions — clarified with precision.</p>
        </div>
      </section>


      {/* FAQ SECTION */}
      <section className="faqs2-container">
        <h2 className="faqs2-title">FREQUENTLY ASKED QUESTIONS</h2>

        <div className="faqs2-list">
          {faqs.map((item, index) => (
            <div key={index} className="faq-item">
              
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3>{item.q}</h3>

                <span className={`faq-icon ${active === index ? "open" : ""}`}>
                  <div></div>
                  <div></div>
                </span>
              </div>

              <div className={`faq-answer ${active === index ? "show" : ""}`}>
                <p>{item.a}</p>
              </div>

            </div>
          ))}
        </div>

      </section>

    </div>
  );
};

export default Faqs;
